import { useRef, useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { $messageCentreStore } from '@lib/store';
import { ValidateUtils } from '@shared/utils';
import type { ThreadWithMessages } from '@shared/api/rest/messages';
import { MessageWrapper } from './messageWrapper';
import { Button, ErrorMessage, Icon, MessageFile, Textarea } from '@shared/widgets';
import PaperclipIcon from '@assets/icons/paperclip.svg';

interface FormSchema {
  message: string;
}

interface IReplyProps {
  thread: ThreadWithMessages;
  onReply: () => void;
}

export const Reply = (props: IReplyProps) => {
  const [file, setFile] = useState<File | undefined>();

  const formControl = useForm<FormSchema>({ mode: 'onChange' });

  const onSubmit: SubmitHandler<FormSchema> = ({ message: body }) => {
    const formData = new FormData();
    file && formData.append('file', file);
    $messageCentreStore.events.addNewMessageToThread({
      groupId: props.thread.groupId,
      body,
      subject: props.thread.subject,
      file: file ? formData : undefined,
    });
    formControl.reset({ message: '' });
    setFile(undefined);
    props.onReply();
  };
  const uploadRef = useRef<HTMLInputElement>(null);
  const upload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
  };

  return (
    <MessageWrapper parentClName='pl-8'>
      <form className='flex-auto min-w-0' onSubmit={formControl.handleSubmit(onSubmit)}>
        <div className='mb-12'>
          <div className='flex flex-col gap-1'>
            <Controller
              name='message'
              control={formControl.control}
              rules={{ required: ValidateUtils.requiredErrorMessage }}
              render={({ field: { onChange, value } }) => (
                <Textarea className='m-0' fitContent placeholder='Enter your message here' rows={5} value={value} onChange={onChange} />
              )}
            />
            <ErrorMessage text={formControl.formState.errors?.message?.message} />
          </div>
        </div>
        <div className='mb-3'>
          {file && (
            <MessageFile downloadShow attachment={{ id: '', filename: file.name, fileSizeBytes: file.size }} onRemove={() => setFile(undefined)} />
          )}
        </div>
        <div className='flex justify-between'>
          <div className='w-72 max-w-[calc(50%-15px)] flex-none'>
            {!file && (
              <div className='mb-6'>
                <input ref={uploadRef} id='contained-button-file' className='hidden' type='file' accept='image/*' onChange={upload} />
                <label htmlFor='contained-button-file'>
                  <Button color='dashed' fullWidth onClick={() => uploadRef.current?.click()}>
                    <Icon icon={<PaperclipIcon />} color='inherit' />
                    Add attachment
                  </Button>
                </label>
              </div>
            )}
          </div>
          <div className='w-72 max-w-[calc(50%-15px)] flex-none'>
            <Button color='primary' type='submit' fullWidth>
              Reply
            </Button>
          </div>
        </div>
      </form>
    </MessageWrapper>
  );
};
